export default __webpack_public_path__ + "static/media/icon1.21163083.jpeg";